import { ApolloProvider } from '@apollo/client';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { ToastNotification } from 'components/ToastNotification/ToastNotification';
import { GlobalStyled } from 'components/_global/Global.styled';
import { useEffect, useState } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { THEME_VARIANT } from 'shared/constants';
import { Wrapper } from 'src/App/App.styled';
import { ThemeContext } from 'src/App/ThemeContext';
import client from 'src/boot/apolloClient';
import RootRoutes from 'src/routes/RootRoutes';
import store from 'state/redux/store';
import { ThemeProvider } from 'styled-components';
import { resolveEnv } from 'utils/helpers';
import themeVariant from 'utils/themeVariant';

export const App = () => {
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [theme, setTheme] = useState(themeVariant[THEME_VARIANT]);

    const clientId =
        '70184062420-tfuat1r5v01l1en7mpj19j3eqdhq8l4h.apps.googleusercontent.com';

    useEffect(() => {
        setTheme(themeVariant[THEME_VARIANT]);
    }, [THEME_VARIANT]);

    return (
        <GoogleOAuthProvider clientId={clientId}>
            <ThemeContext.Provider
                value={{
                    modalIsOpen,
                    setModalIsOpen,
                }}
            >
                <Provider store={store}>
                    <BrowserRouter basename={resolveEnv('PUBLIC_URL')}>
                        <ApolloProvider client={client}>
                            <ThemeProvider theme={theme}>
                                <GlobalStyled lockLayout={modalIsOpen} />
                                <Wrapper>
                                    <ToastNotification />
                                    <RootRoutes />
                                </Wrapper>
                            </ThemeProvider>
                        </ApolloProvider>
                    </BrowserRouter>
                </Provider>
            </ThemeContext.Provider>
        </GoogleOAuthProvider>
    );
};
